import { CommitmentFrequencyEnum } from '@sola/schema/dotcom/cart/commitments.ts';

export const birthdayAppealFrequency = CommitmentFrequencyEnum.Annually;

export const birthdayAppealDefaultAmount = 30;

export const birthdayAppealAmounts = [20, 30, 50, 75, 100] as const;
